import './App.css';
import Navbar from './components/Navbar'
import Footer from './components/Footer'

function App() {
  return (
    <div className="App">
      <Navbar />
      <Footer />  
    </div>
  );
}

export default App;